module.exports = __webpack_public_path__ + "img/left-arrow.9b391c15.svg";